var React = require('react');

function NavbarHome (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m488 312.7v143.3c0 13.3-10.7 24-24 24h-116c-6.6 0-12-5.4-12-12v-112c0-6.6-5.4-12-12-12h-72c-6.6 0-12 5.4-12 12v112c0 6.6-5.4 12-12 12h-116c-13.3 0-24-10.7-24-24v-143.3c0-3.6 1.6-7 4.4-9.3l188-154.8c4.4-3.6 10.8-3.6 15.3 0l188 154.8c2.7 2.3 4.3 5.7 4.3 9.3zm83.6-60.9-83.6-68.9v-138.5c0-6.6-5.4-12-12-12h-56c-6.6 0-12 5.4-12 12v72.6l-89.5-73.7c-17.7-14.6-43.3-14.6-61 0l-253.1 208.5c-5.1 4.2-5.8 11.8-1.6 16.9l25.5 31c4.2 5.1 11.8 5.8 16.9 1.6l235.2-193.7c4.4-3.6 10.8-3.6 15.3 0l235.2 193.7c5.1 4.2 12.7 3.5 16.9-1.6l25.5-31c4.2-5.2 3.4-12.7-1.7-16.9z"}));
}

NavbarHome.defaultProps = {"height":"512","viewBox":"0 0 576 512","width":"576"};

module.exports = NavbarHome;

NavbarHome.default = NavbarHome;
